import CreatorsTextSearch from "./CreatorTextSearch"

export default CreatorsTextSearch
